import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useLanguage } from "../contexts/LanguageContext";
import "./css/Footer.css";

export default function Footer() {
  const { t } = useLanguage();
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");

    // REPLACE THESE WITH YOUR ACTUAL EMAILJS KEYS
    // Sign up at https://www.emailjs.com/
    // 1. Create a Service (e.g., Gmail) -> Get Service ID
    // 2. Create an Email Template -> Get Template ID
    // 3. Go to Account > API Keys -> Get Public Key
    const PUBLIC_KEY = "rQvxogaqgJG9H1aso";
    const SERVICE_ID = "service_pqo64vo";
    const TEMPLATE_ID = "template_dm9a61g";

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, {
        publicKey: PUBLIC_KEY,
      })
      .then(
        () => {
          setStatus("success");
          form.current.reset();
          setTimeout(() => setStatus(""), 5000);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setStatus("error");
        }
      );
  };

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <h2 className="footer-title">{t("footer.getInTouch")}</h2>

        <form className="footer-form" ref={form} onSubmit={sendEmail}>
          <div className="footer-form-grid">
            {/* Left column: name, email, phone */}
            <div className="footer-left">
              <label htmlFor="name" className="footer-label">
                {t("footer.nameLabel")}
              </label>
              <input
                id="name"
                name="user_name"
                type="text"
                placeholder={t("footer.namePlaceholder")}
                className="footer-input"
                required
              />

              <label htmlFor="email" className="footer-label">
                {t("footer.emailLabel")}
              </label>
              <input
                id="email"
                name="user_email"
                type="email"
                placeholder={t("footer.emailPlaceholder")}
                className="footer-input"
                required
              />

              <label htmlFor="phone" className="footer-label">
                {t("footer.phoneLabel")}
              </label>
              <input
                id="phone"
                name="user_phone"
                type="tel"
                placeholder={t("footer.phonePlaceholder")}
                className="footer-input"
              />
            </div>

            {/* Right column: message */}
            <div className="footer-right">
              <label htmlFor="message" className="footer-label">
                {t("footer.messageLabel")}
              </label>
              <textarea
                id="message"
                name="message"
                placeholder={t("footer.messagePlaceholder")}
                className="footer-textarea"
                required
              ></textarea>
            </div>
          </div>

          <div className="footer-submit-area">
            <button
              type="submit"
              className="footer-button"
              disabled={status === "sending"}
            >
              {status === "sending" ? t("footer.buttonSending") : t("footer.buttonInquire")}
            </button>

            {status === "success" && (
              <p className="status-message success">{t("footer.successStatus")}</p>
            )}
            {status === "error" && (
              <p className="status-message error">{t("footer.errorStatus")}</p>
            )}
          </div>
        </form>

        <div className="footer-info">
          <p>
            {t("footer.copyright")}
          </p>
          <p>flavius_lucacel@yahoo.com</p>
          <div className="footer-social">
            <a
              href="https://www.instagram.com/flavius_lucacel/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/flavius.lucacel"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Facebook"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
